import { render, staticRenderFns } from "./SelfhelpTable.vue?vue&type=template&id=5564b63f&scoped=true"
import script from "./SelfhelpTable.vue?vue&type=script&lang=js"
export * from "./SelfhelpTable.vue?vue&type=script&lang=js"
import style0 from "./SelfhelpTable.vue?vue&type=style&index=0&id=5564b63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564b63f",
  null
  
)

export default component.exports